import { memo, useState, type SyntheticEvent } from "react";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import { loadLocalImage } from "../../../../../../../utils";
import {
  CustomAccordion,
  Icon,
  IconContainer,
  Title,
} from "../styles/MobileCardStyles";
import { CardProps } from "../types";

export const AdvantageMobileCard = memo(
  ({ id, text, icon, hoverText }: CardProps) => {
    const panelId = `panel${id}`;
    const headerId = `card${id}adv-header`;
    const contentId = `card${id}adv-content`;

    const [expanded, setExpanded] = useState<string | false>(false);

    const handleChange =
      (card: string) =>
      (_event: SyntheticEvent, newExpanded: boolean) => {
        setExpanded(newExpanded ? card : false);
      };

    const isExpanded = expanded === panelId;

    return (
      <CustomAccordion
        expanded={isExpanded}
        onChange={handleChange(panelId)}
      >
        <AccordionSummary
          aria-controls={contentId}
          id={headerId}
          expandIcon={<ExpandMoreIcon htmlColor="#146cfa" />}
        >
          <IconContainer>
            <Icon src={loadLocalImage(icon, "advantages")} alt={text} loading="lazy" />
          </IconContainer>

          <Title variant="h6" $isexpanded={isExpanded}>
            {text}
          </Title>
        </AccordionSummary>

        {hoverText && (
          <AccordionDetails id={contentId} aria-labelledby={headerId}>
            {hoverText}
          </AccordionDetails>
        )}
      </CustomAccordion>
    );
  }
);

AdvantageMobileCard.displayName = "AdvantageMobileCard";